import 'css-chunksrc/feature/olo-config/OloConfigModal.module.scss';export default {
  "form_fields": "OloConfigModal_form_fields",
  "field": "OloConfigModal_field"
};